export default (timeout?: number | null) => {
  let debounceTimeoutId: NodeJS.Timeout | undefined;
  function withDebounce(action: () => Promise<void>) {
    if (!timeout) {
      action();
      return;
    }
    if (debounceTimeoutId) {
      clearTimeout(debounceTimeoutId);
    }
    debounceTimeoutId = setTimeout(action, timeout);
  }

  return {
    withDebounce,
  };
};
